const APIError = {
  INVITE_LIMIT_REACHED: 'INVITE_LIMIT_REACHED',
} as const;

export default APIError;
